import { useState } from "react";
import { Link } from "react-router-dom";
export default function Admissible () {

    const [x,setX] = useState(false)

    function DF(){
        if(document.getElementById('Ire1').checked
            && document.getElementById('Ire2').checked
            && document.getElementById('Ire3').checked
            && document.getElementById('Ire4').checked
            && document.getElementById('Ire5').checked
            && document.getElementById("Ire6").checked==true
        )
        setX(true) 
        else setX(false)
    }


    return (
        <div class="bg-[#C2F4FF]">
            <div class="bg-pink-500 text-white text-center py-6 px-6">Admission requires a certain mindset</div>
            <div class="px-6 my-4 ">
                <div class="flex justify-center"><div class="py-1 px-2 bg-[#00C2FF] rounded-xl">A</div></div>
                <div class="my-3 text-center">I try ideas, without thinking of startups</div>
                <form><div class="flex flex-row justify-evenly"><div class="flex flex-row gap-1"><div><input onClick={()=>DF()} id="Ire1" type="radio" name="group1"/></div><div>Yes</div></div><div class="flex flex-row gap-1"><div><input  onClick={()=>DF()} name="group1" type="radio"/></div><div>No</div></div></div></form>
            </div>
            <div class="px-6 py-4 bg-[#92EBFF] my-4 ">
                <div class="flex justify-center"><div class="py-1 px-2 bg-[#00C2FF] rounded-xl"> B</div></div>
                <div class="my-3 text-center">None of your peers is a failure</div>
                <form><div class="flex flex-row justify-evenly"><div class="flex flex-row gap-1"><div><input  id="Ire2" onClick={()=>DF()}   name="group2" type="radio"/></div><div>Yes</div></div><div class="flex flex-row gap-1"><div><input onClick={()=>DF()}  name="group2" type="radio"/></div><div>No</div></div></div></form>
            </div>
            <div class="px-6 my-4 ">
                <div class="flex justify-center"><div class="py-1 px-2 bg-[#00C2FF] rounded-xl">C</div></div>
                <div class="my-3 text-center">Getting a job is not the only goal of education</div>
                <form><div class="flex flex-row justify-evenly"><div class="flex flex-row gap-1"><div><input  id="Ire3"  onClick={()=>DF()} name="group3" type="radio"/></div><div>Yes</div></div><div class="flex flex-row gap-1"><div><input onClick={()=>DF()}  name="group3" type="radio"/></div><div>No</div></div></div></form>
            </div>
            <div class="px-6 py-4 my-4 bg-[#92EBFF]  ">
                <div class="flex justify-center"><div class="py-1 px-2 bg-[#00C2FF] rounded-xl">D</div></div>
                <div class="my-3 text-center">Those who have the chance, should try out their passion</div>
                <form><div class="flex flex-row justify-evenly"><div class="flex flex-row gap-1"><div><input  id="Ire4" onClick={()=>DF()}  name="group4" type="radio"/></div><div>Yes</div></div><div class="flex flex-row gap-1"><div><input  onClick={()=>DF()} name="group4" type="radio"/></div><div>No</div></div></div></form>
            </div>
            <div class="px-6 my-4">
                <div class="flex justify-center"><div class="py-1 px-2 bg-[#00C2FF] rounded-xl">E</div></div>
                <div class="my-3 text-center">No student is far or worse of than others</div>
                <form><div class="flex flex-row justify-evenly"><div class="flex flex-row gap-1"><div><input  id="Ire5"  onClick={()=>DF()} name="group5" type="radio"/></div><div>Yes</div></div><div class="flex flex-row gap-1"><div><input onClick={()=>DF()}  name="group5" type="radio"/></div><div>No</div></div></div></form>
            </div>
            <div class="px-6 py-4 my-4 bg-[#92EBFF]">
                <div class="flex justify-center"><div class="py-1 px-2 bg-[#00C2FF] rounded-xl">F</div></div>
                <div>We should respect differences in people and be inclusive of their past life </div>
                <form><div class="flex flex-row justify-evenly"><div class="flex flex-row gap-1"><div><input  id="Ire6"  onClick={()=>DF()} name="group6" type="radio"/></div><div>Yes</div></div><div class="flex flex-row gap-1"><div><input onClick={()=>DF()} name="group6" type="radio"/></div><div>No</div></div></div></form>
            </div>
            <div class="mt-8 pb-8 flex flex-col justify-center">
                {!x&&<div class="my-4 text-center">Not yet!</div>}
                <div class="flex mb-8">{x?<div class={`m-auto px-4 py-2 rounded-2xl bg-blue-700 text-white`}><Link to="/signUp">SUBMIT</Link></div>:<div class={`m-auto px-4 py-2 rounded-2xl bg-gray-300 text-gray-700`}>SUBMIT</div>}</div>
            </div>
        </div>
    );
}